import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const pillars = [
  {
    heading: "Premium Fleet",
    body: "Mercedes-Benz S-Class, Cadillac Escalade, Genesis G90, and Sprinter Van. All black, professionally maintained, fully insured.",
    image: "/premium_fleet.png",
  },
  {
    heading: "Available 24/7",
    body: "Book any time, day or night. We recommend 6-12 hours advance notice. Same-day requests accommodated when available.",
    image: "/24_7_clock.png",
  },
  {
    heading: "Professional Chauffeurs",
    body: "Trained, courteous, and discreet. Flight tracking and baggage claim meet-and-greet on every airport pickup.",
    image: "/Professional_Chauffeurs.png",
  },
];

export default function WhyUs() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      id="why-us"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: "#111111" }}
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.025]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #c9a84c 0, #c9a84c 1px, transparent 0, transparent 50%)",
          backgroundSize: "24px 24px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 24 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p className="text-gold tracking-[0.3em] text-xs uppercase mb-4 font-medium">
            The Sagar Difference
          </p>
          <h2 className="section-heading">Why Choose Us</h2>
          <div className="gold-divider" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((p, i) => (
            <motion.div
              key={p.heading}
              initial={{ opacity: 0, y: 32 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.15 + i * 0.12,
              }}
              className="text-center flex flex-col items-center border border-white/5 overflow-hidden"
              style={{ background: "#1a1a1a" }}
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img src={p.image} alt={p.heading} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent" />
              </div>

              <div className="w-8 h-px bg-gold mt-6 mb-6" />

              <h3 className="font-display text-cream text-xl font-medium mb-3 px-6">
                {p.heading}
              </h3>
              <p className="text-cream/55 text-sm leading-relaxed max-w-xs px-6 pb-8">
                {p.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
